<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>{{ $t('enum.unsold') }}</h2>
      <div class="input_blue">
        <el-input :placeholder="$t('enum.searchForItems')" v-model="searchKey" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="getData()"></el-button>
        </el-input>
      </div>
    </div>

    <div class="main_tabs_box">
      <ul class="main_tabs">
        <li @click="changeByWay(2)" :class="byWay==2?'on':''">{{ $t('enum.auction') }}</li>
        <li @click="changeByWay(1)" :class="byWay==1?'on':''">{{ $t('enum.buyItNow') }}</li>
      </ul>
      <div class="main_total">{{Count}} {{ $t('enum.items') }}</div>
    </div>
    <table-check :list="List" :showType="showType" :byWay="byWay==2?'Auction':'BuyItNow'" @getData="getData" v-loading="loading"
      @dialogSwitch="dialogSwitch" :loading="loading" />
    <list-pagination v-show="Count>0" ref="Pagination" :total="Count" @getData="getData" />

    <dialog-unload ref="UnloadDialog" v-if="dialogShow" :dialogType="dialogType" :dialogCardObj="dialogCardObj" @dialogSwitch="dialogSwitch"
      @getData="getData" @dialogClose="dialogClose"></dialog-unload>
  </div>
</template>

<script>
import TableCheck from '@/components/tablecheck'
import ListPagination from '@/components/listpagination'
import DialogUnload from '@/components/dialog/dialog-unload'
export default {
  name: '',
  components: { TableCheck, ListPagination, DialogUnload },
  data() {
    return {
      loading: true, //page loading
      msgTabs: 0,
      UserInfo: this.$store.state.UserInfo,
      List: [],
      showType: 'Unsold',//Unsold Scheduled
      Count: 0,
      searchKey: '',
      PageIndex: 1,
      PageSize: 60,
      byWay: 2,//2=拍卖,1=一口价
      listType: 3,//1=已上架，2=即将上架，3=已下架 Unsold：listType=3，Scheduled：listType=2
      sortType: 1,//1=最快结束时间，2=价格（高-低），3=价格（低-高），4=最新发布，5出价次数（高-低）
      isSort: 1,
      /*unload-dialog*/
      dialogShow: false,
      dialogType: '',
      dialogCardObj: {},
    }
  },
  created: function () {
    var that = this;
  },
  mounted: function () {
    var that = this;
    that.getData();
    //var priceExchange = this.$store.getters.priceExchange(16);
  },
  methods: {
    // 上架弹框
    dialogSwitch(val, obj) {
      /*unload-dialog*/
      this.dialogShow = true;
      this.dialogType = val;
      if (obj) {
        this.dialogCardObj = obj;
      }
    },
    // 关闭弹框
    dialogClose() {
      this.dialogShow = false;
    },
    // 获取我的商品列表
    getData(PageIndex, PageSize) {
      var that = this;
      if (PageIndex && PageSize) { that.PageIndex = PageIndex; that.PageSize = PageSize; }
      let _searchKey = encodeURIComponent(that.searchKey);
      let params = `?pageIndex=${that.PageIndex}&pageSize=${that.PageSize}&searchKey=${_searchKey}&byWay=${that.byWay}&listType=${that.listType}&sortType=${that.sortType}`;
      that.loading = true;
      that.List = [];
      that.Count = 0;
      let fun = function (res) {
        that.loading = false;
        console.log(res)
        if (res.result) {
          var _data = res.data
          that.List = _data;
          that.Count = res.count;
        }
      };
      that.$get('SearchMyCommodities', params)//我的 商品列表
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
          that.loading = false;
        });
    },
    // 获取对应类型的我的商品列表
    changeByWay(val) {
      let that = this;
    // 切换Unsold 的tab类型
      that.byWay = val;
      that.PageIndex = 1;
      if (that.$refs.Pagination) {
        that.$refs.Pagination.PageIndex = 1;
      }
      that.getData();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_total {
  position: absolute;
  right: 12px;
  top: 22px;
}
</style>



// WEBPACK FOOTER //
// src/pages/commodity/unsold.vue